import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TestGuardGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {


    const topicTitles = {
      officeSetup: 'Office 365 Setup',
      googleSetup: 'Google Setup',
      deviceSetup: 'Android/iOS Setup',
      quickStart: 'Quick Start Guide',
      usingDash: 'Using Dash',
      practices: 'Practices'
    };
    const guideSubArticles = {
      'o365-powershell' : 'Office 365 Powershell',
      'o365-enterprise-application': 'Enterprise Application',
      'o365-service-account': 'Service Account',
      'google-service-account': 'Google Workspace service account',
      'google-personal-account': 'Google Workspace or personal account'
    };

    const article = next.params.id;

    if (!topicTitles.hasOwnProperty(article) && !guideSubArticles.hasOwnProperty(article)) {
      return this.router.parseUrl('/guide');
    }
    return true;
  }

}
